import React, { Component, Fragment } from 'react';
import ReactDOM from 'react-dom';
import './dialog.less';
import { GdImage } from '@gaodun.com/gui-pc';

interface LeaveDialogProps {
    imageSrc: any;
    statusChange: any;
    errorText: string;
    okText: string;
    notFooterBtn?: boolean;
    closeBtn?: boolean;
    retainRedirectValue?: string;
}
class LeaveDialog extends Component<LeaveDialogProps & Props> {
    constructor(props) {
        super(props);
        this.statusChange = this.statusChange.bind(this);
    }

    statusChange = (status: Boolean, cb: any) => {
        this.props.statusChange(status);
        cb && cb();
    };
    handleClickPic = link => {
        // 关闭按钮 => 自定义
        if (this.props.closeBtn) {
            if (!!link) {
                window.open(link);
            } else {
                this.statusChange(false, undefined);
            }
        }
    };
    render() {
        const { imageSrc, errorText, okText, closeBtn, retainRedirectValue } = this.props;
        return ReactDOM.createPortal(
            <Fragment>
                <div className="mask" />
                <div className="dialog">
                    <div className="dialog-container">
                        <div className="dialog-body">
                            <GdImage src={imageSrc} onClick={() => this.handleClickPic(retainRedirectValue)} />
                        </div>
                        {!closeBtn ? (
                            <div className="dialog-footer">
                                <span className="dialog-button dialog-refuse-button" onClick={() => this.statusChange(false, undefined)}>
                                    {errorText || '忍痛拒绝'}
                                </span>
                                <span className="dialog-button dialog-sure-button" onClick={() => this.statusChange(false, undefined)}>
                                    {okText || '继续支付'}
                                </span>
                            </div>
                        ) : (
                            <div className="dialog-footer" onClick={() => this.statusChange(false, undefined)}>
                                <div className="dialog-close-btn">
                                    <i className="iconfont iconclose"></i>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </Fragment>,
            document.body
        );
    }
}
export default LeaveDialog;
